/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmTokenCardListInfo } from '../models/EvmTokenCardListInfo';
import type { EvmTokenDetailInfo } from '../models/EvmTokenDetailInfo';
import type { EvmTokenInfo } from '../models/EvmTokenInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmTokenControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmTokenInfo OK
     * @throws ApiError
     */
    public getEvmTokenInfo({
        ca,
    }: {
        ca: string,
    }): CancelablePromise<EvmTokenInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/info',
            query: {
                'ca': ca,
            },
        });
    }

    /**
     * @returns EvmTokenInfo OK
     * @throws ApiError
     */
    public getEvmTokenInfo1({
        ca,
    }: {
        ca: string,
    }): CancelablePromise<EvmTokenInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/info',
            query: {
                'ca': ca,
            },
        });
    }

    /**
     * @returns EvmTokenCardListInfo OK
     * @throws ApiError
     */
    public getEvmTokenCardList(): CancelablePromise<EvmTokenCardListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/card/list',
        });
    }

    /**
     * @returns EvmTokenCardListInfo OK
     * @throws ApiError
     */
    public getEvmTokenCardList1(): CancelablePromise<EvmTokenCardListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/card/list',
        });
    }

    /**
     * @returns EvmTokenDetailInfo OK
     * @throws ApiError
     */
    public getEvmTokenDetailInfo({
        ca,
        tokenType,
        tokenId,
    }: {
        ca: string,
        tokenType: 'NA' | 'CA' | 'ERC20' | 'ERC721' | 'ERC1155',
        tokenId?: string,
    }): CancelablePromise<EvmTokenDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token',
            query: {
                'ca': ca,
                'tokenType': tokenType,
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns EvmTokenDetailInfo OK
     * @throws ApiError
     */
    public getEvmTokenDetailInfo1({
        ca,
        tokenType,
        tokenId,
    }: {
        ca: string,
        tokenType: 'NA' | 'CA' | 'ERC20' | 'ERC721' | 'ERC1155',
        tokenId?: string,
    }): CancelablePromise<EvmTokenDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token',
            query: {
                'ca': ca,
                'tokenType': tokenType,
                'tokenId': tokenId,
            },
        });
    }

}
